var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 22C44 32.9811 35.9545 42.0827 25.4375 43.7327V28.3594H30.5637L31.5391 22H25.4375V17.8733C25.4375 16.133 26.29 14.4375 29.0228 14.4375H31.7969V9.02344C31.7969 9.02344 29.2789 8.59375 26.8718 8.59375C21.847 8.59375 18.5625 11.6394 18.5625 17.1531V22H12.9766V28.3594H18.5625V43.7327C8.04547 42.0827 0 32.9811 0 22C0 9.85016 9.85016 0 22 0C34.1498 0 44 9.85016 44 22Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5637 28.3594L31.5391 22H25.4375V17.8732C25.4375 16.1334 26.2898 14.4375 29.0227 14.4375H31.7969V9.02344C31.7969 9.02344 29.2793 8.59375 26.8722 8.59375C21.8469 8.59375 18.5625 11.6394 18.5625 17.1531V22H12.9766V28.3594H18.5625V43.7326C19.6826 43.9084 20.8306 44 22 44C23.1694 44 24.3174 43.9084 25.4375 43.7326V28.3594H30.5637Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon1);
export default __webpack_public_path__ + "static/media/fb_icon_1.1c6b04cd3927cf0bca951f8124759722.svg";
export { ForwardRef as ReactComponent };